import Vue from 'vue';
import moment from 'moment';

Vue.filter('dateFilter', function(value: any, format: string) {
  if(value) {
    return moment(value).format(format);
  }

  return value;
});